// extracted by mini-css-extract-plugin
export default {"tooltipWrap":"SelectControl_tooltipWrap__DwDRe","imageOption":"SelectControl_imageOption__XMhm1","label":"SelectControl_label__tai7j"};